import { mtLocation } from "./mt-location"

export function isInternalLink(href: string | null | undefined): boolean {
  // no window during SSR; callers fall back to their external-link behavior
  if (typeof window === "undefined") return false

  const currentHost = mtLocation.host

  if (href?.startsWith("/")) return true
  try {
    const linkHost = new URL(href ?? "", mtLocation.origin).host
    return linkHost === currentHost
  } catch {
    return false
  }
}
